/**
 * Axios client for the Manager Assistant data API (/ma/*), authenticated with
 * the manager phone+PIN JWT. Drop-in replacement for the shared apiClient in
 * the manager pages: same call shape (maClient.get('/manager/alerts')), but it
 * targets /ma/* and sends the manager token. On 401 it clears the session and
 * sends the user back to the Manager Assistant login.
 */
import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosError } from 'axios';
import { getToken, logout } from './manager-auth';
import { pa } from '../../pages/manager/base';

const API_URL = import.meta.env.VITE_API_URL || 'https://roniapi.data-corner.com.au';

const maClient: AxiosInstance = axios.create({
  baseURL: `${API_URL}/ma`,
  timeout: 300000,
  headers: { 'Content-Type': 'application/json' },
});

maClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error: AxiosError) => Promise.reject(error),
);

maClient.interceptors.response.use(
  (r) => r,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      logout();
      if (!window.location.pathname.startsWith(pa('/login'))) {
        window.location.href = pa('/login');
      }
    }
    return Promise.reject(error);
  },
);

export default maClient;
